<template>
  <div class="absolute panel-gui z-10 bg-white-transp cursor-default p-4">
    <div class=" text-2xl">
      Make a Building
    </div>
    <div class="flex">
      <div class=" cursor-pointer" :key="bd._id" v-for="bd in buildings.list" @click="choose({ building: bd })">
        <img class="w-48 h-64 object-cover object-center" :src="bd.img" :alt="bd.name" :tite="bd.name">
        <div class="flex justify-center mt-2">
          {{ bd.displayName }}
        </div>
      </div>
    </div>
    <!-- <div class="w-full h-64">
      <GamePlayCanvas></GamePlayCanvas>
    </div> -->
  </div>
</template>

<script>
import { Buildings } from '../Buildings.js'
import { O3DG2 } from '../../../Reusable/O3DG2'
let list = new Buildings()
export default {
  props: {
    shown: {}
  },
  components: {
    // GamePlayCanvas: require('../../../Canvas/GamePlayCanvas').default
  },
  mixins: [O3DG2],
  data () {
    return {
      buildings: list
    }
  },
  methods: {
    choose ({ building }) {
      this.ctx.current.slot.set = building.name
      this.$emit('close')
    }
  },
  computed: {
  },
  mounted () {
    // this.$watch('shown', () => {
    //   window.dispatchEvent(new Event('resize'))
    // })
  }
}
</script>

<style lang="postcss">
.bg-white-transp {
  background-color: rgba(255, 255, 255, 0.76);
}
.panel-gui{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
@screen lg {
  .panel-gui {
    top: 20px;
    left: 20px;
    width: calc(100% - 20px * 2);
    height: calc(100% - 20px * 2);
  }
}
</style>